/*
 * AMM — rotate the "Recent warehouse highlights" grid.
 *
 * The section renders a fixed set of product cards on the server so the page
 * still has real product links without JavaScript. This script then replaces
 * that fixed set with a random selection drawn from the whole catalog, so the
 * section shows different products on every page load.
 *
 * If the request fails, times out, or the catalog is too small, the
 * server-rendered cards are left exactly as they are.
 */
(function () {
  'use strict';

  var FALLBACK_MONEY_FORMAT = '${{amount}}';
  var REQUEST_TIMEOUT_MS = 4000;
  var IMAGE_WIDTHS = [320, 520, 720, 900];

  function shuffle(list) {
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = list[i];
      list[i] = list[j];
      list[j] = swap;
    }
    return list;
  }

  function escapeHtml(value) {
    return String(value === null || value === undefined ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  // products.json returns prices as decimal strings in the shop currency
  // ("25.00"), not in cents — do not divide by 100.
  function formatMoney(value, format) {
    var amount = Number(value).toFixed(2).split('.');
    amount[0] = amount[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var rendered = amount[0] + '.' + amount[1];
    var template = format || FALLBACK_MONEY_FORMAT;
    if (template.indexOf('{{') === -1) return '$' + rendered;
    return template.replace(/\{\{\s*amount\s*\}\}/g, rendered);
  }

  function sizedUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function pickPrice(variants) {
    var result = { price: null, compare: null, available: false };
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var value = parseFloat(variant.price);
      if (result.price === null || value < result.price) {
        result.price = value;
        result.compare = variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;
      }
      if (variant.available) result.available = true;
    }
    return result;
  }

  function cardHtml(product, moneyFormat) {
    var image = product.images && product.images.length ? product.images[0] : null;
    var pricing = pickPrice(product.variants || []);
    var title = product.title || '';
    var url = '/products/' + (product.handle || '');
    var safeTitle = escapeHtml(title);

    var media = '';
    if (image) {
      var ratio = image.width && image.height ? image.height / image.width : 1;
      var srcset = IMAGE_WIDTHS.map(function (width) {
        return sizedUrl(image.src, width) + ' ' + width + 'w';
      }).join(', ');
      media = '<img src="' + sizedUrl(image.src, 900) + '" alt="' + safeTitle + '" srcset="' + srcset +
        '" width="900" height="' + Math.round(900 * ratio) + '" loading="lazy" sizes="(min-width: 990px) 25vw, 50vw">';
    }
    if (!pricing.available) {
      media += '<span class="amm-editorial-product-card__badge">Sold out</span>';
    }

    var price = pricing.price === null ? '' : formatMoney(pricing.price, moneyFormat);
    if (pricing.compare && pricing.price !== null && pricing.compare > pricing.price) {
      price += ' <s>' + formatMoney(pricing.compare, moneyFormat) + '</s>';
    }

    return '<article class="amm-editorial-product-card">' +
      '<a class="amm-editorial-product-card__media" href="' + url + '">' + media + '</a>' +
      '<div class="amm-editorial-product-card__meta">' +
      '<div><h3><a href="' + url + '">' + safeTitle + '</a></h3><p>' + price + '</p></div>' +
      '<a href="' + url + '" aria-label="View ' + safeTitle + '">\u2192</a>' +
      '</div>' +
      '</article>';
  }

  function rotate(grid) {
    var visible = parseInt(grid.getAttribute('data-visible'), 10) || 8;
    var endpoint = grid.getAttribute('data-endpoint');
    var moneyFormat = grid.getAttribute('data-money-format') || FALLBACK_MONEY_FORMAT;
    if (!endpoint || typeof window.fetch !== 'function') return;

    var restingVisibility = grid.style.visibility;
    var settled = false;
    var timer = null;

    function reveal() {
      if (settled) return;
      settled = true;
      if (timer) window.clearTimeout(timer);
      grid.style.visibility = restingVisibility;
    }

    // Hold the server-rendered cards back until we know whether we can rotate,
    // so visitors never see one set of products swap for another.
    grid.style.visibility = 'hidden';
    timer = window.setTimeout(reveal, REQUEST_TIMEOUT_MS);

    window.fetch(endpoint, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var catalog = (data && data.products) || [];
        var pool = catalog.filter(function (product) {
          return product && product.images && product.images.length;
        });
        if (pool.length <= visible) throw new Error('catalog too small to rotate');
        var picked = shuffle(pool.slice()).slice(0, visible);
        grid.innerHTML = picked.map(function (product) {
          return cardHtml(product, moneyFormat);
        }).join('');
        reveal();
      })
      .catch(reveal);
  }

  function boot() {
    var grids = document.querySelectorAll('[data-amm-product-rotation]');
    for (var i = 0; i < grids.length; i++) rotate(grids[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
